import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { Globe, Plus } from 'lucide-react';
import './Registrationfee.css';

const url = process.env.REACT_APP_BACKEND_URL;

const AddRegistrationfee = () => {
  const [submitting, setSubmitting] = useState(false);
  const [data, setData] = useState({
    name: "",
    amount: ""
  });
  const [focusedFields, setFocusedFields] = useState({
    name: false,
    amount: false,
  });

  const navigate = useNavigate();

  const handleFocus = (field) => {
    setFocusedFields(prev => ({ ...prev, [field]: true }));
  };

  const handleBlur = (field) => {
    setFocusedFields(prev => ({ ...prev, [field]: data[field].length > 0 }));
  };

  const onChangeHandler = (event) => {
    const { name, value } = event.target;
    setData(prevData => ({ ...prevData, [name]: value }));
  };

  const onSubmitHandler = async (event) => {
    event.preventDefault();

    if (!data.name.trim()) {
      toast.error("Registration name is required");
      return;
    }
    if (!data.amount || isNaN(data.amount)) {
      toast.error("Registration amount is required and must be a number");
      return;
    }

    try {
      setSubmitting(true);
      const response = await axios.post(`${url}/api/registerfee`, {
        name: data.name,
        amount: Number(data.amount)
      });

      if (response.data.success) {
        toast.success("Registration fee added successfully!");
        setData({ name: "", amount: "" }); // reset fields
        navigate('/ViewRegistrationfee'); // ensure route exists
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to add Registration fee";
      toast.error(errorMessage);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-wrapper">
      <div className="country-form-container">
        <h2 className="form-title">
          <Globe size={20} className="inline mr-2" /> Add New Registration Fee
        </h2>
        <div className="header" style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '20px' }}>
          <button onClick={() => navigate('/ViewRegistrationfee')} className="add-button">
            <Plus size={16} /> View Registration Fees
          </button>
        </div>

        <form className="country-form" onSubmit={onSubmitHandler}>
          <div className={`form-field ${focusedFields.name || data.name ? 'filled' : ''}`}>
            <input
              type="text"
              name="name"
              value={data.name}
              onChange={onChangeHandler}
              onFocus={() => handleFocus('name')}
              onBlur={() => handleBlur('name')}
              required
            />
            <label>Registration Name</label>
          </div>

          <div className={`form-field ${focusedFields.amount || data.amount ? 'filled' : ''}`}>
            <input
              type="number"
              name="amount"
              value={data.amount}
              onChange={onChangeHandler}
              onFocus={() => handleFocus('amount')}
              onBlur={() => handleBlur('amount')}
              required
            />
            <label>Registration Amount</label>
          </div>

          <button type="submit" className="submit-btn" disabled={submitting}>
            {submitting ? "Processing..." : "Add Registration Fee"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddRegistrationfee;
